<template>
  <v-container fluid class="user-list" v-if="languageData.modalDelete">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1 px-3 py-4">
        <v-card-text>
          <v-row no-gutters align="center" width="100%">
            <div class="search-input-container">
               <v-text-field
                  class="search-input"
                  background-color="bgDefault"
                  height="55px"
                  single-line
                  flat
                  solo
                  hide-details
                  @keyup="filtersProjects"
                  v-model="searchProject"
                  :placeholder="languageData.search"
                  :label="languageData.search"
                  prepend-inner-icon="mdi-magnify"></v-text-field>
            </div>
            <div class="search-button-container">
              <v-btn height="55px" width="100%" class="search-button" to="/projects/add" color="primary">
                <v-icon class="mr-2">mdi-plus</v-icon>
                {{ languageData.btnAddText }}
              </v-btn>
            </div>   
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-data-table
            loading-text="Loading... Please wait"
            class="users-table"
            :search="searchProject"
            :headers="headers"
            :options.sync="pagination"
            :server-items-length="totalItems"
            :items-per-page-options="rowsPerPageItems"
            :footer-props="footerOptions"
            :page.sync="currentPage"
            :items="dataReceive"
            :loading="loadingProjects"
            mobile-breakpoint="0"
            >
            <template v-slot:item.logo="{ item }">
              <v-avatar :color="item.hexColor" size="40" class="mr-2" style="cursor: pointer" @click="previewProject(item.id)">
                <span class="white--text headline">{{ getFirstLetter(item.name) }}</span>
              </v-avatar>
            </template>
            <template v-slot:item.net_value="{ item }">
              {{ item.net_value !== null ? item.net_value + '€' : null }}
            </template>
            <template v-slot:item.estimation_value="{ item }">
              {{ item.estimation_value !== null ? item.estimation_value + '€' : null}}
            </template>
            <template v-slot:item.address="{ item }">
              <td class="justify-center">
                {{ item['address']['street'] }} {{ item['address']['flat_number'] }}<br/>
                {{ item['address']['postal_code'] }} {{ item['address']['city'] }}
              </td>
            </template>
            <template v-slot:item.actions="{ item }" v-if="languageData.operation">
              <td class="justify-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="previewProject(item.id)"
                        icon>
                      <v-icon color="fontDefault">preview</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.operation.preview }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="editProject(item.id)"
                        icon>
                      <v-icon color="fontDefault">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.operation.edit }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="showDeleteProjectModal(item)">
                      <v-icon color="fontDefault">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.operation.delete }}</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>
    <ModalInfo  :typeInfo="modalDeleteInfoData.typeInfo" :headModal="modalDeleteInfoData.head" :btnAgreeText="languageData.btnAgreeText" @clicked="hideModalDeleteInfo" :show-modal="isShowDeleteModalInfo" :text-modal="modalDeleteInfoData.textInfo"></ModalInfo>
    <ModalInfo  :typeInfo="modalSaveInfoData.typeInfo" :headModal="modalSaveInfoData.head" :btnAgreeText="languageData.btnAgreeText" @clicked="hideModalSaveInfo" :show-modal="isShowSaveModalInfo" :text-modal="modalSaveInfoData.textInfo"></ModalInfo>
    <ModalInfo @doOperation="deleteProject" :isLoadingBtn="false" :idData="modalDeleteData.idData" :typeInfo="modalDeleteData.typeInfo" :headModal="modalDeleteData.head" :btnDisAgreeText="languageData.modalDelete.btnDisAgreeText" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="true" @clicked="hideModalDelete" :show-modal="isShowDeleteModal" :text-modal="modalDeleteData.textInfo"></ModalInfo>
  </v-container>
</template>

<script type="text/javascript">
  import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
  import {mapActions, mapState} from "vuex";
  import eventBus from "../../../../event-bus/eventBus";
  import router from "../../../../../router";

  export default {
    name: "ListProjects",
    components: {
      ModalInfo
    },
    data() {
      return {
        searchProject: null,
        footerOptions: {
          'items-per-page-options': [20, 50, 100],
          'disablePagination': false
        },
        currentPage: 1,
        modalSaveInfoData: {},
        isShowSaveModalInfo: false,
        searchTask: null,
        searchDebouceTime: 500
      }
    },
    computed: {
      ...mapState("getProjects", {
        dataReceive: state => state.dataReceive,
        headers: state => state.headers,
        totalItems: state => state.pagination.totalItems,
        rowsPerPageItems: state => state.pagination.rowsPerPage,
        sortBy: state => state.pagination.sortBy,
        loadingProjects: state => state.loadingProjects
      }),
      ...mapState("deleteProject", {
        isShowDeleteModal: state => state.isShowDeleteModal,
        isLoadingDeleteModal: state => state.isLoadingDeleteModal,
        isShowDeleteModalInfo: state => state.isShowDeleteModalInfo,
        modalDeleteData: state => state.modalDeleteData,
        modalDeleteInfoData: state => state.modalDeleteInfoData
      }),
      pagination: {
        set: function(value) {
          this.searchProjects(value);
        },
        get: function() {
          return this.$store.state.getProjects.pagination;
        }
      }
    },
    methods: {
      hideModalDelete: function() {
        this.hideModalDeleteAction();
      },
      hideModalDeleteInfo: function() {
        this.hideModalDeleteInfoAction();
      },
      filtersProjects: function() {
        clearTimeout(this.searchTask);
        this.searchTask = setTimeout(() => {this.searchProjects({}, true)}, this.searchDebouceTime);
      },
      searchProjects: function(valueSearch={}, filters=false) {
          valueSearch.language = this.getCurrentLanguage;
          valueSearch.filters = filters;
          valueSearch.search = this.searchProject;
          this.getProjects({valueSearch});
          if(filters) {
            this.currentPage = 1;
          }
      },
      hideModalSaveInfo: function() {
        this.isShowSaveModalInfo = false;
      },
      showDeleteProjectModal: function(item) {
        let modalDeleteData = {};
        modalDeleteData.name  = item.name;
        modalDeleteData.id = item.id;
        modalDeleteData.index = this.dataReceive.indexOf(item);
        modalDeleteData.languageData = this.languageData.modalDeleteProject;
        this.showModalDeleteData(modalDeleteData);
      },
      deleteProject: function(value) {
        this.deleteProjectRequest(value);
      },
      editProject: function(id) {
        router.push({ path:"/projects/edit", query: { id: id } });
      },
      previewProject: function(id) {
        router.push({ path:"/projects/edit", query: { id: id } });
      },
      estimateProject: function(id) {
        router.push({ path:"/projects/estimation", query: { id: id } });
      },
      getFirstLetter: function(firstname) {
        return firstname.charAt(0);
      },
      ...mapActions("getProjects", ["getProjects", "getHeadersTable"]),
      ...mapActions("deleteProject", ["deleteProjectRequest", "showDeleteModal", "showModalDeleteData", "hideModalDeleteAction", "hideModalDeleteInfoAction"])
    },
    mounted() {
      if(localStorage.getItem("textProjectSave")) {
        this.modalSaveInfoData.typeInfo = "success";
        this.modalSaveInfoData.textInfo = localStorage.getItem("textProjectSave");
        this.modalSaveInfoData.head = localStorage.getItem("messageProjectSave");
        this.isShowSaveModalInfo = true;
        localStorage.removeItem("textProjectSave");
        localStorage.removeItem("messageProjectSave");
      }
      const language = this.getCurrentLanguage;
      this.getHeadersTable({creds: {language}});
      eventBus.$on("changeLanguage", (value) => {
        const language = value;
        this.getHeadersTable({creds: {language}});
      });
      eventBus.$on("deleteItem", (id, invoiceExists) =>{
        if (!invoiceExists) {
          this.dataReceive.splice(this.modalDeleteData.index, 1);
        }
      });
      eventBus.$on("setDisablePagination", (value) => {
        this.footerOptions["disablePagination"] = value;
      });
    }
  }
</script>